import { ITableCell, ITableRow } from '../../../../store/mst/Upload/models';

export interface RowErrors {
  [key: string]: string;
}

export interface CellWithDependencyMeta {
  cell: ITableCell,
  dependsOn?: ITableCell
}

export interface CustomValidatorArgs {
  value: string | undefined,
  dependsOn?: string,
  columnKey: string,
  countryCode?: string,
  type?: string,
  row?: ITableRow,
  locationHeaders?: any
}

export interface CellRecord {
  [key: string]: any
}

export enum CSVUploadSteps {
  MAP = 'map',
  CONFIRM = 'confirm',
}
